import request from '../../utils/request';
// import getCookie from "../../utils/cookie";


export default {

  // 获取专业列表
  getRelationList(params) {
    return request.get('api/relation/list', {params})
  },

  //添加专业
  addRelation(params) {
    return request.post('/api/relation/add', params);
  },

  // 编辑查看专业
  editRelation(params) {
    return request.get('/api/relation/edit', {params});
  },

  // 更新专业
  updateRelation(params) {
    return request.post(`/api/relation/update?id=${params.id}`, params);
  },

  //删除专业
  deleteRelation(params) {
    return request.get('/api/relation/delete', {params});
  },

  // excel专业模版下载
  downloadRelation(params) {
    return request({
        method: 'get',
        url: '/api/relation/download',
        params: params,
      }
    )
  },

  //后台课程列表
  getAcademicPlanning(params) {
    return request.get('/api/academic-planning/search', {params});
  },

  // 添加课程
  addAcademicPlanning(data) {
    let formData = new FormData()
    Object.keys(data).forEach(key => {
      formData.append(key, data[key])
    })
    return request(
      {
        method: 'post',
        url: '/api/academic-planning/add',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData,
      }
    );
  },

  //修改课程
  editAcademicPlanning(params) {
    return request.post('/api/academic-planning/edit', params);
  },

  //获取下拉框筛选数据
  academicPlanningSelect(params) {
    return request.get('/api/academic-planning/get-filter-items', {params});
  },

  //删除课程
  deleteAcademicPlanning(params) {
    return request.post('/api/academic-planning/delete', params);
  },

  //发布预览
  academicPlanningPrev(params) {
    return request.get('/api/academic-planning/search-class', {params});
  },

  //发布课程
  releaseAcademicPlanning(params) {
    return request.post('/api/academic-planning/release', params);
  },

  //编辑培养计划标题
  editRelationTitle(params) {
    return request.post(`/api/relation/title-edit?id=${params.id}`, params);
  },

  //查询培养计划标题
  getRelationTitle(params) {
    return request.get('/api/relation/get-title', {params});
  },

}
